/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  getStorege,
  removeStorege,
  saveStorege,
  updateRequestStorege,
} from '../db_storage';
import { checkCartStorege } from '../utils/Check';

export const handleSaveCartStorage = (
  product: any,
  params: any,
  type: string,
  key: string,
): any => {
  let checkDateTime = false;
  let idRequestMenu = 0;
  const dateTimeRequest = `${new Date()}`;
  const dataShopResquetStorage = getStorege(key);
  const dataShopResquetStorageCart = getStorege(
    params.promotion
      ? '@mais/delivery/shop/request/product/cart/promotion'
      : '@mais/delivery/shop/request/product/cart',
  );

  const pedidoCardapioTotal = getStorege(
    '@mais/delivery/shop/request/product/cart',
  );

  if (dataShopResquetStorage?.dateTimeRequest) {
    checkDateTime = checkCartStorege(
      dataShopResquetStorage.dateTimeRequest,
      60,
    );
    if (checkDateTime) {
      removeStorege(key);
    }
  }

  const idShopStorege = dataShopResquetStorage?.idRestaurante
    ? window.atob(dataShopResquetStorage?.idRestaurante)
    : 0;

  if (parseInt(dataShopResquetStorageCart?.idPedidoCardapioTotal, 10) > 0) {
    idRequestMenu =
      parseInt(dataShopResquetStorageCart?.idPedidoCardapioTotal, 10) + 1;
  } else if (parseInt(pedidoCardapioTotal?.idPedidoCardapioTotal, 10) > 0) {
    idRequestMenu =
      parseInt(pedidoCardapioTotal?.idPedidoCardapioTotal, 10) + 1;
  } else {
    idRequestMenu = 1;
  }
  if (idShopStorege === params.idShop && !checkDateTime) {
    const resultUpdate = updateRequestStorege(
      key,
      {
        idPedidoCardapio: idRequestMenu,
        qtItens: params.incrementQt,
        vlItem: params.vlProduct,
        dsDescricao: product.dsDescricao,
        vlItemOriginal: product.vlItem,
        vlItemTotal: params.vlProduct,
        dsObservacao: params.observation,
        dsImagem: product.dsImagem ? product.dsImagem : params.dsImagem,
        dsNome: product.dsNome,
        idCardapio: product.idCardapio,
        idSituacao: params.idSituacao,
        idPromocao: product.idPromocao,
        promotionMaxStage: params.promotionMaxStage,
        vlDescontoItem: product.vlDescontoItem,
        tpCalculoSabor: product.tpCalculoSabor,
        idIncrementa: product.idIncrementa,
        flgMaiorIdade: product.flgMaiorIdade,
        promotionDeliveryFree:
          params.promotionDeliveryFree ||
          dataShopResquetStorageCart?.promotionDeliveryFree,
      },
      type,
      idRequestMenu,
    );

    if (resultUpdate?.remove) {
      return resultUpdate;
    }
    return { idPedidoCardapio: idRequestMenu };
  }

  saveStorege(key, {
    idPedidoCardapioTotal: idRequestMenu,
    idRestaurante: params.idRestaurante,
    pedido: {
      idRestaurante: params.idShop,
    },
    dateTimeRequest,
    idSituacao: params.idSituacao,
    dsImagemEstabelecimento: params.dsImagemEstabelecimento,
    dsNomeEstabelecimento: params.dsNomeEstabelecimento,
    promotionDeliveryFree:
      params.promotionDeliveryFree ||
      dataShopResquetStorageCart?.promotionDeliveryFree,
    pedido_cardapio: [
      {
        idPedidoCardapio: idRequestMenu,
        qtItens: params.incrementQt,
        vlItem: params.vlProduct,
        vlItemOriginal: product.vlItem,
        dsDescricao: product.dsDescricao,
        vlItemTotal: params.vlProduct,
        dsObservacao: params.observation,
        dsImagem: product.dsImagem ? product.dsImagem : params.dsImagem,
        dsNome: product.dsNome,
        idCardapio: product.idCardapio,
        idPromocao: product.idPromocao,
        promotionMaxStage: params.promotionMaxStage,
        vlDescontoItem: product.vlDescontoItem,
        idIncrementa: product.idIncrementa,
        tpCalculoSabor: product.tpCalculoSabor,
        flgMaiorIdade: product.flgMaiorIdade,
      },
    ],
  });

  return { idPedidoCardapio: idRequestMenu };
};
